import { writable, get } from 'svelte/store';


const { subscribe, set, update } = writable({
	urn: '',
	route: '',
	path: '',
	params: {},
	query: {},
	meta: {},
	parentRoute: '',
});


export const currentRoute = {
	subscribe,
	
	/* next */
	next: (o, m) => update((self) => {
		return Object.assign(self, o, m);
	}),

	/* pull */
	pull: prop =>
		prop ? get(currentRoute)[prop] : get(currentRoute),
};
